interface HintTooltipProps {
  text: string;
  align?: "left" | "right";
}

export function HintTooltip({ text, align = "right" }: HintTooltipProps) {
  const alignment = align === "right" ? "right-0" : "left-0";
  return (
    <span className="group relative inline-flex">
      <span
        aria-label={text}
        role="tooltip"
        className="inline-flex h-4 w-4 cursor-help select-none items-center justify-center rounded-full bg-info/15 font-mono text-[10px] font-bold text-info-text transition-colors hover:bg-info/30 hover:text-info-text-strong"
      >
        ?
      </span>
      <span
        className={`pointer-events-none absolute bottom-[calc(100%+6px)] ${alignment} z-30 w-60 max-w-xs rounded-md border border-info/30 bg-surface-tooltip/95 px-3 py-2 text-left text-[11.5px] font-normal normal-case leading-snug tracking-normal text-fg-secondary opacity-0 shadow-[0_8px_24px_rgba(15,23,42,0.18)] ring-1 ring-info/10 backdrop-blur transition-opacity duration-150 group-hover:opacity-100 dark:shadow-[0_8px_24px_rgba(0,0,0,0.5)]`}
      >
        {text}
      </span>
    </span>
  );
}
